/**
 * Created by Administrator on 2018/8/24.
 */
const serviceModule = {
  getproduct: {
    url: '',
    method: 'get'
  },
  getlist: {
    url: '',
    method: 'get'
  },
  getarea: {
    url: '',
    method: 'get'
  },
  getindustry:{
    url: '',
    method: 'get'
  },
  postformsubmit:{
    url: '',
    method: 'post'
  }
}
const ApiSetting = {...serviceModule }

export default ApiSetting



// WEBPACK FOOTER //
// ./src/api/apiSetting.js